import React from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../Tables";

export class TagTableColumn extends BaseTableColumn {
    @autobind
    addToSearch(text) {
        const { AddToSearch } = this.props.CustomData;

        if(AddToSearch) {
            AddToSearch(text);
        }
    }

    @autobind
    _render() {
        const { Value } = this.props;

        if(!Value) {
            return null;
        }

        return Value.map(x => (
            <span className="file-tag"
                  onClick={() => this.addToSearch(x.Tag.shortName)}
                  key={x.fileUploadTagId}
            >
                {x.Tag.shortName}
            </span>
        ));
    }
}
